import { DeepMap } from 'react-hook-form';
import { CreateScheduleShiftInput } from 'apollo/generated/client-operations';
import { ensureNonUndefinedFields, getAsNumber } from 'utils';
import { getUpdateInputValueFunction } from 'components/form';
import { JobsiteScheduleShiftFormFields } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';

export { getFormInputs } from './EditShiftModal.forms';

export const getDefaultValues = (): JobsiteScheduleShiftFormFields => {
  return {
    startTime: '06:00 am',
    duration: 8,
  };
};

export const getAddInput = (
  scheduleId: string,
  data: JobsiteScheduleShiftFormFields,
  dirtyFields: DeepMap<JobsiteScheduleShiftFormFields, true>,
): CreateScheduleShiftInput => {
  const getUpdateInputValue = getUpdateInputValueFunction(data, dirtyFields);

  return ensureNonUndefinedFields<CreateScheduleShiftInput>({
    scheduleId,
    startTime: getUpdateInputValue('startTime', true),
    duration: getAsNumber(getUpdateInputValue('duration', true)),
  });
};
